import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopGeoRegionItemFragmentDoc, ShopGeoRegionDetailFragmentDoc } from './shop-region.gql.generated';
import { ShopPaymentFragmentDoc } from './shop-payment.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopUserFragment = { __typename: 'ShopUserObject', id: number, firstName: string, lastName: string, email: string, phone?: string | null | undefined, paymentMethods: Array<{ __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } }> };

export type ShopUserPaymentMethodFragment = { __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } };

export type ShopAddressFragment = { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined };

export type ShopUserAddressFragment = { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined, region?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined } | null | undefined };

export type ShopUserAgreementFragment = { __typename: 'ShopUserAgreementObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed: boolean };

export type ShopUserOrderFragment = { __typename: 'ShopOrderObject', number?: string | null | undefined, createdAt: any, checkoutAt?: any | null | undefined, total: number, currency?: string | null | undefined, state: Types.OrderState, id: number, shippingAddress?: { __typename: 'ShopAddressObject', street?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, subscriber?: { __typename: 'ShopSubscriberObject', id: number, subscriptionName: string } | null | undefined, items: Array<{ __typename: 'ShopOrderItemObject', media: { __typename: 'ShopProductMediaObject', url: string, type: string } }> };

export type ShopUserRegistrationMutationVariables = Types.Exact<{
  firstName: Types.Scalars['String']['input'];
  lastName: Types.Scalars['String']['input'];
  email: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
  phone?: Types.InputMaybe<Types.Scalars['String']['input']>;
  attributes?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
}>;


export type ShopUserRegistrationMutation = { __typename: 'Mutation', registerUser: { __typename: 'LoginObject', token: string, userId: number, expiresAt: any, issuedAt: any } };

export type ShopUserLoginMutationVariables = Types.Exact<{
  credentials: Types.CredentialsInput;
}>;


export type ShopUserLoginMutation = { __typename: 'Mutation', loginUser: { __typename: 'LoginObject', token: string, expiresAt: any, issuedAt: any, userId: number } };

export type ShopCreateUserAddressMutationVariables = Types.Exact<{
  input: Types.ShopCreateUserAddressInput;
}>;


export type ShopCreateUserAddressMutation = { __typename: 'Mutation', shopCreateUserAddress: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } };

export type ShopUpdateUserAddressMutationVariables = Types.Exact<{
  input: Types.ShopUpdateUserAddressInput;
}>;


export type ShopUpdateUserAddressMutation = { __typename: 'Mutation', shopUpdateUserAddress: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } };

export type ShopDeleteUserAddressMutationVariables = Types.Exact<{
  input: Types.ShopDeleteUserAddressInput;
}>;


export type ShopDeleteUserAddressMutation = { __typename: 'Mutation', shopDeleteUserAddress: { __typename: 'ShopMutationResult', id: number } };

export type ForgotPasswordMutationVariables = Types.Exact<{
  credentials: Types.ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename: 'Mutation', forgotPassword: { __typename: 'ForgotPasswordObject', email: string } };

export type ResetPasswordMutationVariables = Types.Exact<{
  credentials: Types.ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', resetPassword: { __typename: 'ForgotPasswordObject', email: string } };

export type ShopUpdateUserMutationVariables = Types.Exact<{
  input: Types.ShopUpdateUserInput;
}>;


export type ShopUpdateUserMutation = { __typename: 'Mutation', shopUpdateUser: { __typename: 'ShopUserObject', id: number, firstName: string, lastName: string, email: string, phone?: string | null | undefined, paymentMethods: Array<{ __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } }> } };

export type ShopUpdateUserPasswordMutationVariables = Types.Exact<{
  input: Types.ShopUpdateUserPasswordInput;
}>;


export type ShopUpdateUserPasswordMutation = { __typename: 'Mutation', shopUpdateUserPassword: { __typename: 'ShopUserObject', id: number } };

export type ShopArchiveUserPaymentMethodMutationVariables = Types.Exact<{
  input: Types.ArchiveUserPaymentMethodInput;
}>;


export type ShopArchiveUserPaymentMethodMutation = { __typename: 'Mutation', shopArchiveUserPaymentMethod: { __typename: 'ShopMutationResult', id: number } };

export type ShopCreateUserPaymentMethodMutationVariables = Types.Exact<{
  input: Types.ShopCreateUserPaymentMethodInput;
}>;


export type ShopCreateUserPaymentMethodMutation = { __typename: 'Mutation', shopCreateUserPaymentMethod: { __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } } };

export type ShopCancelUserPaymentMethodMutationVariables = Types.Exact<{
  input: Types.ShopCancelUserPaymentMethodInput;
}>;


export type ShopCancelUserPaymentMethodMutation = { __typename: 'Mutation', shopCancelUserPaymentMethod: { __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } } };

export type ShopRefreshUserMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ShopRefreshUserMutation = { __typename: 'Mutation', refreshUser: { __typename: 'LoginObject', token: string, expiresAt: any, issuedAt: any, userId: number } };

export type ShopUserDeclarationMutationVariables = Types.Exact<{
  input: Types.ShopUserDeclarationInput;
}>;


export type ShopUserDeclarationMutation = { __typename: 'Mutation', shopUserDeclaration: Array<{ __typename: 'ShopUserAgreementObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed: boolean }> };

export type ShopUserPaymentMethodQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ShopUserPaymentMethodQuery = { __typename: 'Query', shopUserPaymentMethod: { __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } } };

export type ShopUserAuthQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ShopUserAuthQuery = { __typename: 'Query', shopAuthUser: { __typename: 'ShopUserObject', id: number, firstName: string, lastName: string, email: string, phone?: string | null | undefined, paymentMethods: Array<{ __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } }> } };

export type ShopUserAddressesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ShopUserAddressesQuery = { __typename: 'Query', shopAuthUser: { __typename: 'ShopUserObject', addresses: Array<{ __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined, region?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined } | null | undefined }> } };

export type ShopUserRefreshPaymentMethodsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ShopUserRefreshPaymentMethodsQuery = { __typename: 'Query', shopAuthUser: { __typename: 'ShopUserObject', paymentMethods: Array<{ __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } }> } };

export type ShopUserPaymentMethodsQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  states?: Types.InputMaybe<Array<Types.UserPaymentMethodState> | Types.UserPaymentMethodState>;
}>;


export type ShopUserPaymentMethodsQuery = { __typename: 'Query', shopUserPaymentMethods: Array<{ __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState, isLastUsed?: boolean | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number } }> };

export type ShopUserOrderDetailQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ShopUserOrderDetailQuery = { __typename: 'Query', shopOrder: { __typename: 'ShopOrderObject', id: number, number?: string | null | undefined, state: Types.OrderState, channelCode: string, currency?: string | null | undefined, total: number, checkoutAt?: any | null | undefined, couponCode?: string | null | undefined, items: Array<{ __typename: 'ShopOrderItemObject', id: number, productId: number, productName: string, variantId: number, variantName?: string | null | undefined, quantity: number, total: number, unitPrice: number, unitsTotal: number, source: Types.OrderItemSource, media: { __typename: 'ShopProductMediaObject', url: string, type: string } }>, shippingAddress?: { __typename: 'ShopAddressObject', street?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, suburb?: string | null | undefined, country: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, payments: Array<{ __typename: 'ShopPaymentObject', id: number, amount: number, currency: string, state: Types.PaymentState, referenceNumber: string, description: string, errorDescription?: string | null | undefined, publicAttributes?: any | null | undefined, method: { __typename: 'ShopPaymentMethodObject', id: number, code: string, provider: string, name: string, canReuse: boolean, expressCheckoutEnabled: boolean, fullScreenPaymentEnabled: boolean, publicAttributes?: { __typename: 'StripePublicClientAttributes', apiKeyPublic?: string | null | undefined } | null | undefined } }>, shipment?: { __typename: 'ShopShipmentObject', slotStartAt?: any | null | undefined, slotEndAt?: any | null | undefined, methodName?: string | null | undefined } | null | undefined, subscriber?: { __typename: 'ShopSubscriberObject', id: number, subscriptionName: string } | null | undefined } };

export type ShopUserOrdersQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  states?: Types.InputMaybe<Array<Types.OrderState> | Types.OrderState>;
  sort?: Types.InputMaybe<Types.ShopSortInput>;
  page?: Types.InputMaybe<Types.ShopPageInput>;
  year?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ShopUserOrdersQuery = { __typename: 'Query', itemsCount: number, items: Array<{ __typename: 'ShopOrderObject', number?: string | null | undefined, createdAt: any, checkoutAt?: any | null | undefined, total: number, currency?: string | null | undefined, state: Types.OrderState, id: number, shippingAddress?: { __typename: 'ShopAddressObject', street?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined, subscriber?: { __typename: 'ShopSubscriberObject', id: number, subscriptionName: string } | null | undefined, items: Array<{ __typename: 'ShopOrderItemObject', media: { __typename: 'ShopProductMediaObject', url: string, type: string } }> }> };

export type ShopUserOrderItemQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ShopUserOrderItemQuery = { __typename: 'Query', shopOrder: { __typename: 'ShopOrderObject', items: Array<{ __typename: 'ShopOrderItemObject', id: number, variantId: number, quantity: number, productName: string, productId: number, media: { __typename: 'ShopProductMediaObject', url: string, type: string } }> } };

export const ShopUserPaymentMethodFragmentDoc = gql`
    fragment ShopUserPaymentMethod on ShopUserPaymentMethodObject {
  id
  activatedAt
  expiresAt
  description
  publicAttributes
  isExpired
  state
  isLastUsed
  method {
    id
  }
}
    `;
export const ShopUserFragmentDoc = gql`
    fragment ShopUser on ShopUserObject {
  id
  firstName
  lastName
  email
  phone
  paymentMethods {
    ...ShopUserPaymentMethod
  }
}
    ${ShopUserPaymentMethodFragmentDoc}`;
export const ShopAddressFragmentDoc = gql`
    fragment ShopAddress on ShopAddressObject {
  id
  type
  alias
  firstName
  lastName
  email
  phoneNumber
  street
  complex
  suburb
  city
  businessName
  postalCode
  province
  country
  instructions
  hash
  coordinates
  isDefaultShippingAddress
  isDefaultBillingAddress
  recipientHash
}
    `;
export const ShopUserAddressFragmentDoc = gql`
    fragment ShopUserAddress on ShopAddressObject {
  id
  type
  alias
  firstName
  lastName
  email
  phoneNumber
  street
  complex
  suburb
  city
  businessName
  postalCode
  province
  country
  instructions
  hash
  coordinates
  isDefaultShippingAddress
  isDefaultBillingAddress
  recipientHash
  region {
    ...ShopGeoRegionItem
  }
}
    ${ShopGeoRegionItemFragmentDoc}`;
export const ShopUserAgreementFragmentDoc = gql`
    fragment ShopUserAgreement on ShopUserAgreementObject {
  id
  name
  label
  termsUrls
  agreed
}
    `;
export const ShopUserOrderFragmentDoc = gql`
    fragment ShopUserOrder on ShopOrderObject {
  number
  createdAt
  checkoutAt
  shippingAddress {
    street
    city
    postalCode
    province
    country
    firstName
    lastName
  }
  total
  currency
  state
  id
  subscriber {
    id
    subscriptionName
  }
  items {
    media {
      url
      type
    }
  }
}
    `;
export const ShopUserRegistrationDocument = gql`
    mutation ShopUserRegistration($firstName: String!, $lastName: String!, $email: String!, $password: String!, $phone: String = null, $attributes: JSON) {
  registerUser(
    credentials: {email: $email, firstName: $firstName, lastName: $lastName, password: $password, phone: $phone, attributes: $attributes}
  ) {
    token
    userId
    expiresAt
    issuedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserRegistrationGQL extends Apollo.Mutation<ShopUserRegistrationMutation, ShopUserRegistrationMutationVariables> {
    document = ShopUserRegistrationDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserLoginDocument = gql`
    mutation ShopUserLogin($credentials: CredentialsInput!) {
  loginUser(credentials: $credentials) {
    token
    expiresAt
    issuedAt
    userId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserLoginGQL extends Apollo.Mutation<ShopUserLoginMutation, ShopUserLoginMutationVariables> {
    document = ShopUserLoginDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopCreateUserAddressDocument = gql`
    mutation ShopCreateUserAddress($input: ShopCreateUserAddressInput!) {
  shopCreateUserAddress(input: $input) {
    ...ShopAddress
  }
}
    ${ShopAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCreateUserAddressGQL extends Apollo.Mutation<ShopCreateUserAddressMutation, ShopCreateUserAddressMutationVariables> {
    document = ShopCreateUserAddressDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUpdateUserAddressDocument = gql`
    mutation ShopUpdateUserAddress($input: ShopUpdateUserAddressInput!) {
  shopUpdateUserAddress(input: $input) {
    ...ShopAddress
  }
}
    ${ShopAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUpdateUserAddressGQL extends Apollo.Mutation<ShopUpdateUserAddressMutation, ShopUpdateUserAddressMutationVariables> {
    document = ShopUpdateUserAddressDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopDeleteUserAddressDocument = gql`
    mutation ShopDeleteUserAddress($input: ShopDeleteUserAddressInput!) {
  shopDeleteUserAddress(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopDeleteUserAddressGQL extends Apollo.Mutation<ShopDeleteUserAddressMutation, ShopDeleteUserAddressMutationVariables> {
    document = ShopDeleteUserAddressDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($credentials: ForgotPasswordInput!) {
  forgotPassword(credentials: $credentials) {
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForgotPasswordGQL extends Apollo.Mutation<ForgotPasswordMutation, ForgotPasswordMutationVariables> {
    document = ForgotPasswordDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation ResetPassword($credentials: ResetPasswordInput!) {
  resetPassword(credentials: $credentials) {
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUpdateUserDocument = gql`
    mutation ShopUpdateUser($input: ShopUpdateUserInput!) {
  shopUpdateUser(input: $input) {
    ...ShopUser
  }
}
    ${ShopUserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUpdateUserGQL extends Apollo.Mutation<ShopUpdateUserMutation, ShopUpdateUserMutationVariables> {
    document = ShopUpdateUserDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUpdateUserPasswordDocument = gql`
    mutation ShopUpdateUserPassword($input: ShopUpdateUserPasswordInput!) {
  shopUpdateUserPassword(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUpdateUserPasswordGQL extends Apollo.Mutation<ShopUpdateUserPasswordMutation, ShopUpdateUserPasswordMutationVariables> {
    document = ShopUpdateUserPasswordDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopArchiveUserPaymentMethodDocument = gql`
    mutation ShopArchiveUserPaymentMethod($input: ArchiveUserPaymentMethodInput!) {
  shopArchiveUserPaymentMethod(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopArchiveUserPaymentMethodGQL extends Apollo.Mutation<ShopArchiveUserPaymentMethodMutation, ShopArchiveUserPaymentMethodMutationVariables> {
    document = ShopArchiveUserPaymentMethodDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopCreateUserPaymentMethodDocument = gql`
    mutation ShopCreateUserPaymentMethod($input: ShopCreateUserPaymentMethodInput!) {
  shopCreateUserPaymentMethod(input: $input) {
    ...ShopUserPaymentMethod
  }
}
    ${ShopUserPaymentMethodFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCreateUserPaymentMethodGQL extends Apollo.Mutation<ShopCreateUserPaymentMethodMutation, ShopCreateUserPaymentMethodMutationVariables> {
    document = ShopCreateUserPaymentMethodDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopCancelUserPaymentMethodDocument = gql`
    mutation ShopCancelUserPaymentMethod($input: ShopCancelUserPaymentMethodInput!) {
  shopCancelUserPaymentMethod(input: $input) {
    ...ShopUserPaymentMethod
  }
}
    ${ShopUserPaymentMethodFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCancelUserPaymentMethodGQL extends Apollo.Mutation<ShopCancelUserPaymentMethodMutation, ShopCancelUserPaymentMethodMutationVariables> {
    document = ShopCancelUserPaymentMethodDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopRefreshUserDocument = gql`
    mutation ShopRefreshUser {
  refreshUser {
    token
    expiresAt
    issuedAt
    userId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopRefreshUserGQL extends Apollo.Mutation<ShopRefreshUserMutation, ShopRefreshUserMutationVariables> {
    document = ShopRefreshUserDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserDeclarationDocument = gql`
    mutation ShopUserDeclaration($input: ShopUserDeclarationInput!) {
  shopUserDeclaration(input: $input) {
    ...ShopUserAgreement
  }
}
    ${ShopUserAgreementFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserDeclarationGQL extends Apollo.Mutation<ShopUserDeclarationMutation, ShopUserDeclarationMutationVariables> {
    document = ShopUserDeclarationDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserPaymentMethodDocument = gql`
    query ShopUserPaymentMethod($id: Int!) {
  shopUserPaymentMethod(id: $id) {
    ...ShopUserPaymentMethod
  }
}
    ${ShopUserPaymentMethodFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserPaymentMethodGQL extends Apollo.Query<ShopUserPaymentMethodQuery, ShopUserPaymentMethodQueryVariables> {
    document = ShopUserPaymentMethodDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserAuthDocument = gql`
    query ShopUserAuth {
  shopAuthUser {
    ...ShopUser
  }
}
    ${ShopUserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserAuthGQL extends Apollo.Query<ShopUserAuthQuery, ShopUserAuthQueryVariables> {
    document = ShopUserAuthDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserAddressesDocument = gql`
    query ShopUserAddresses {
  shopAuthUser {
    addresses {
      ...ShopUserAddress
    }
  }
}
    ${ShopUserAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserAddressesGQL extends Apollo.Query<ShopUserAddressesQuery, ShopUserAddressesQueryVariables> {
    document = ShopUserAddressesDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserRefreshPaymentMethodsDocument = gql`
    query ShopUserRefreshPaymentMethods {
  shopAuthUser {
    paymentMethods {
      ...ShopUserPaymentMethod
    }
  }
}
    ${ShopUserPaymentMethodFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserRefreshPaymentMethodsGQL extends Apollo.Query<ShopUserRefreshPaymentMethodsQuery, ShopUserRefreshPaymentMethodsQueryVariables> {
    document = ShopUserRefreshPaymentMethodsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserPaymentMethodsDocument = gql`
    query ShopUserPaymentMethods($id: Int!, $states: [UserPaymentMethodState!]) {
  shopUserPaymentMethods(userId: $id, states: $states) {
    ...ShopUserPaymentMethod
  }
}
    ${ShopUserPaymentMethodFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserPaymentMethodsGQL extends Apollo.Query<ShopUserPaymentMethodsQuery, ShopUserPaymentMethodsQueryVariables> {
    document = ShopUserPaymentMethodsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserOrderDetailDocument = gql`
    query ShopUserOrderDetail($id: Int!) {
  shopOrder(id: $id) {
    id
    number
    state
    channelCode
    currency
    total
    checkoutAt
    couponCode
    items {
      id
      productId
      productName
      variantId
      variantName
      quantity
      total
      unitPrice
      unitsTotal
      media {
        url
        type
      }
      source
    }
    shippingAddress {
      street
      city
      postalCode
      province
      suburb
      country
      firstName
      lastName
    }
    payments {
      ...ShopPayment
    }
    shipment {
      slotStartAt
      slotEndAt
      methodName
    }
    subscriber {
      id
      subscriptionName
    }
  }
}
    ${ShopPaymentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserOrderDetailGQL extends Apollo.Query<ShopUserOrderDetailQuery, ShopUserOrderDetailQueryVariables> {
    document = ShopUserOrderDetailDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserOrdersDocument = gql`
    query ShopUserOrders($userId: Int!, $states: [OrderState!], $sort: ShopSortInput, $page: ShopPageInput, $year: Int) {
  items: shopOrders(
    userId: $userId
    states: $states
    page: $page
    sort: $sort
    year: $year
  ) {
    ...ShopUserOrder
  }
  itemsCount: shopOrdersCount(userId: $userId, states: $states, year: $year)
}
    ${ShopUserOrderFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserOrdersGQL extends Apollo.Query<ShopUserOrdersQuery, ShopUserOrdersQueryVariables> {
    document = ShopUserOrdersDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUserOrderItemDocument = gql`
    query ShopUserOrderItem($id: Int!) {
  shopOrder(id: $id) {
    items {
      id
      variantId
      quantity
      productName
      productId
      media {
        url
        type
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUserOrderItemGQL extends Apollo.Query<ShopUserOrderItemQuery, ShopUserOrderItemQueryVariables> {
    document = ShopUserOrderItemDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }